export default function MatchingDemo() {
  return (
    <section className="mb-24">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-extrabold mb-3">
          Only your shared desires make the list
        </h2>
        <p className="text-slate-400 text-sm">
          Mismatches disappear. Only the good stuff stays.
        </p>
      </div>

      <div className="space-y-6 px-2 max-w-md mx-auto">

        {/* Perfect Match */}
        <div className="relative group transition-all duration-300 ease-out hover:scale-105 hover:rotate-1 z-30">
          <div className="absolute -top-3 left-6 z-10 bg-primary text-white text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg border border-white/20 shadow-lg flex items-center gap-1.5">
            <span className="material-symbols-outlined text-[14px]">favorite</span>
            Perfect Match
          </div>
          <div className="bg-purple-card border-2 border-primary p-6 rounded-[2rem] glow-pink flex items-center gap-5">
            <div className="text-4xl drop-shadow-md shrink-0">🙈</div>
            <div className="flex-1 min-w-0">
              <h3 className="font-extrabold text-xl text-white mb-1">Use Blindfolds?</h3>
              <div className="text-sm text-slate-300 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 sm:flex sm:flex-wrap sm:gap-x-5 sm:gap-y-0.5 sm:items-center">
                <div className="contents sm:flex sm:items-center sm:gap-x-2">
                  <span className="text-slate-500">You</span>
                  <span className="whitespace-nowrap">🔥 Hell yes!</span>
                </div>
                <div className="contents sm:flex sm:items-center sm:gap-x-2">
                  <span className="text-slate-500">Partner</span>
                  <span className="whitespace-nowrap">🔥 Hell yes!</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Great Match */}
        <div className="relative group transition-all duration-300 ease-out hover:scale-105 hover:-rotate-1 z-20">
          <div className="absolute -top-3 left-6 z-10 bg-[#064e3b] text-match-green text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg border border-match-green/20 shadow-lg flex items-center gap-1.5">
            <span className="material-symbols-outlined text-[14px]">check_circle</span>
            Great Match
          </div>
          <div className="bg-purple-card border border-match-green/50 p-6 rounded-[2rem] glow-green flex items-center gap-5">
            <div className="text-4xl drop-shadow-md shrink-0">👩‍⚕️</div>
            <div className="flex-1 min-w-0">
              <h3 className="font-extrabold text-xl text-white mb-1">Nurse Roleplay?</h3>
              <div className="text-sm text-slate-300 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 sm:flex sm:flex-wrap sm:gap-x-5 sm:gap-y-0.5 sm:items-center">
                <div className="contents sm:flex sm:items-center sm:gap-x-2">
                  <span className="text-slate-500">You</span>
                  <span className="whitespace-nowrap">🤔 Curious</span>
                </div>
                <div className="contents sm:flex sm:items-center sm:gap-x-2">
                  <span className="text-slate-500">Partner</span>
                  <span className="whitespace-nowrap">🔥 Hell yes!</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden */}
        <div className="relative group transition-all duration-300 ease-out hover:scale-105 hover:rotate-1 z-10">
          <div className="absolute -top-3 left-6 z-10 bg-slate-700 text-slate-400 text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg border border-white/5 shadow-lg flex items-center gap-1.5">
            <span className="material-symbols-outlined text-[14px]">visibility_off</span>
            Hidden
          </div>
          <div className="bg-purple-card/40 border border-white/5 p-6 rounded-[2rem] grayscale-[0.5] group-hover:grayscale-0 transition-all flex items-center gap-5">
            <div className="text-4xl opacity-50 shrink-0">👀</div>
            <div className="flex-1 min-w-0">
              <h3 className="font-extrabold text-xl mb-1 privacy-blur">Public Play?</h3>
              <div className="text-sm text-slate-400 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 sm:flex sm:flex-wrap sm:gap-x-5 sm:gap-y-0.5 sm:items-center">
                <div className="contents sm:flex sm:items-center sm:gap-x-2">
                  <span className="text-slate-500">You</span>
                  <span className="whitespace-nowrap">🚫 Pass</span>
                </div>
                <div className="contents sm:flex sm:items-center sm:gap-x-2">
                  <span className="text-slate-500">Partner</span>
                  <span className="whitespace-nowrap">🔥 Hell yes!</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
